<template>
  <div>
    <div class="row">
      <button class="btn btn-success" @click.prevent="add"><i class="fas fa-plus"></i></button>
    </div>
    <hr />
    <div v-if="fields.length === 0">
      Nessun campo aggiunto
    </div>
    <div class="form-row mb-2" v-for="(field, index) in fields">
      <div class="col-auto">
        <input class="form-control" type="text" :name="`fields[${index}][key]`" placeholder="Chiave" v-model="field.key">
      </div>
      <div class="col-auto">
        <input class="form-control" type="text" :name="`fields[${index}][title]`" placeholder="Titolo" v-model="field.title"/>
      </div>
      <div class="col-auto">
        <b-form-select :name="`fields[${index}][type]`" v-model="field.type" :options="options"></b-form-select>
      </div>
      <div class="col-auto">
        <button @click.prevent="configure(index)" class="btn btn-primary">Configura</button>
      </div>
      <input v-for="option in field.options" type="hidden" :name="`fields[${index}][options][]`" :value="option" />
      <input v-if="field.yes !== null" type="hidden" :name="`fields[${index}][yes]`" :value="field.yes" />
      <input v-if="field.no !== null" type="hidden" :name="`fields[${index}][no]`" :value="field.no" />
      <input v-if="field.checkboxText" type="hidden" :name="`fields[${index}][checkboxText]`" :value="field.checkboxText" />
      <input v-if="field.yesnoTitle" type="hidden" :name="`fields[${index}][yesnoTitle]`" :value="field.yesnoTitle" />
      <input v-if="field.sectionCode" type="hidden" :name="`fields[${index}][sectionCode]`" :value="field.sectionCode" />
      <input v-if="field.required" type="hidden" :name="`fields[${index}][required]`" :value="field.required">
      <div class="col row justify-content-end">
        <div class="col-auto btn-group">
          <button @click.prevent="moveUp(index)" :disabled="index === 0" class="btn btn-outline-success"><i class="fas fa-arrow-up"></i></button>
          <button @click.prevent="moveDown(index)" :disabled="(index + 1) === fields.length" class="btn btn-outline-success"><i class="fas fa-arrow-down"></i></button>
        </div>
        <div class="col-auto">
          <button @click.prevent="remove(index)" class="btn btn-danger"><i class="fas fa-times"></i></button>
        </div>
      </div>
    </div>
    <hr />

    <b-modal ref="configureModal" @hidden="modalHiding" id="modal-1" title="Configura">
      <div v-if="selectedField !== null">
        <div class="form-group" v-if="selectedField.type === 'select'">
          <b-form-tags add-button-text="Aggiungi" placeholder="Aggiungi opzione" v-model="selectedField.options"></b-form-tags>
        </div>
        <div class="form-group" v-if="selectedField.type === 'yesno'">
          <b-form-input type="text" v-model="selectedField.yes" placeholder="Si"></b-form-input>
        </div>
        <div class="form-group" v-if="selectedField.type === 'yesno'">
          <b-form-input type="text" v-model="selectedField.no" placeholder="No"></b-form-input>
        </div>
        <div class="form-group" v-if="selectedField.type === 'yesno'">
          <b-form-input type="text" v-model="selectedField.yesnoTitle" placeholder="Testo Si/No"></b-form-input>
        </div>
        <div class="form-group" v-if="selectedField.type === 'checkbox'">
          <b-form-input type="text" v-model="selectedField.checkboxText" placeholder="Testo Checkbox"></b-form-input>
        </div>
        <div v-if="selectedField.type === 'section'" class="form-group" style="height: 300px;">
          <ace-editor v-model="selectedField.sectionCode" @init="editorInit" lang="html"></ace-editor>
        </div>
        <div
          class="form-group"
          v-if="['string', 'date', 'checkbox'].includes(selectedField.type)"
        >
          <b-form-checkbox v-model="selectedField.required">
            Richiesto
          </b-form-checkbox>
        </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="ok">
          Chiudi
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: "DynamicInsertForm",
    data() {
      return {
        fields: this.previousFields,
        selectedField: null,
        selectedFieldIndex: null,
        options: [
          { value: null, text: "Seleziona un tipo" },
          { value: "string", text: "Stringa" },
          { value: "date", text: "Data" },
          { value: "select", text: "Selezione"},
          { value: "checkbox", text: "Checkbox" },
          { value: "yesno", text: "Si/No"},
          { value: "section", text: "Sezione"}
        ],
        editorOptions: {
          showGutter: true
        },
      }
    },
    props: {
      previousFields: {
        type: Array,
      }
    },
    methods: {
      add() {
        this.fields.push({
          title: "",
          type: null,
        });
      },
      remove(index) {
        this.fields.splice(index, 1);
      },
      configure(index) {
        this.selectedField = this.fields[index];
        this.selectedFieldIndex = index;
        this.$refs.configureModal.show();
      },
      modalHiding() {
        this.selectedField = null;
        this.selectedFieldIndex = null;
      },
      saveConfiguration() {
        this.fields[this.selectedFieldIndex] = this.selectedField;
      },
      editorInit(editor) {
        require('ace-builds/src-min-noconflict/ext-language_tools');
        require('ace-builds/src-min-noconflict/mode-html');
        require('ace-builds/src-min-noconflict/theme-ambiance');
        editor.session.setMode("ace/mode/html");
        editor.commands.addCommand({
          name: "save",
          exec: this.save,
          bindKey: {mac: "cmd-s", win: "ctrl-s"}
        });
        editor.setOptions(this.editorOptions);
      },
      moveUp(index) {
        const b = this.fields[index - 1];
        Vue.set(this.fields, index - 1, this.fields[index]);
        Vue.set(this.fields, index, b);
      },
      moveDown(index) {
        const b = this.fields[index + 1];
        Vue.set(this.fields, index + 1, this.fields[index]);
        Vue.set(this.fields, index, b);
      }
    }
  }
</script>

<style scoped>

</style>
